import { createSlice } from "@reduxjs/toolkit";

const initialState:any = {
    contactAttributes: [],
    selectedMenu:"active",
    selectedContact: "",
    emailDetails:"",
    selectedContactDetails: "",
    emailLoading:false,
    emailAction:'',
    emailConnections:[],
    inboxList:[],
    outboxList:[],
    failedEmailList:[],
    lastEvaluatedKey:"",
    workmailDomain:""
};

const emailSlice = createSlice({
    name: "emailSlice",
    initialState: initialState,
    reducers: {
        addContactAttributes(state, action) {
            let payload = action.payload;
            if(state.contactAttributes.length > 0) {
                let alreadyExists = state.contactAttributes.filter((contact:any) => contact.contactId === payload.contactId)[0]
                if(!alreadyExists) {
                    state.contactAttributes.push(payload);
                }
            } else {
                state.contactAttributes.push(payload);
            }
            state.selectedContact = payload.contactId
        },
        setSelectedContact(state, action) {
            let payload = action.payload;
            state.selectedContact = payload;
        },
        setSelectedContactDetails(state, action) {
            let payload = action.payload;
            state.selectedContactDetails = payload   
        },
        removeContactAttributes(state, action) {
            let payload = action.payload;
            state.contactAttributes = payload;
        },
        setEmailLoading(state, action) {
            let payload = action.payload;
            state.emailLoading = payload;
        },
        setSelectedMenu(state, action) {
            let payload = action.payload;
            state.selectedMenu = payload;
        },
        setEmailDetails(state, action) {
            let payload = action.payload;
            state.emailDetails = payload
        },
        setEmailAction(state, action) {
            let payload = action.payload;
            state.emailAction = payload
        },
        createNewEmailConnection(state, action) {
            let payload = action.payload;
            if(state.emailConnections.length > 0) {
                let alreadyExists = state.emailConnections.filter((controller:any) => controller.controller.contactId === payload.controller.contactId)[0]
                if(!alreadyExists) {
                    state.emailConnections.push(payload);
                }
            } else {
                state.emailConnections.push(payload);
            }
        },
        setInboxList(state, action) {
            let payload = action.payload;
            state.inboxList = payload
        }, 
        setOutboxList(state, action) {
            let payload = action.payload;
            state.outboxList = payload
        },
        setFailedEmailList(state, action) {
            let payload = action.payload;
            state.failedEmailList = payload
        },
        setLastEvaluatedKey(state, action) {
            let payload = action.payload;
            state.lastEvaluatedKey = payload
        },
        setWorkmailDomain(state, action) {
            let payload = action.payload;
            state.workmailDomain = payload
        }
    },
});

export const emailSliceAction = emailSlice.actions;
export default emailSlice.reducer;